import React from 'react'
import styles from "../../../../../assets/styles/componentStyles/chatbotStyles/chats.module.scss"
import globalStyles from "../../../../../assets/styles/global.module.scss";
import { Divider, Grid, Typography } from '@mui/material';
import { talkToAgentExecutionData } from '../../../../../models/axiosModel';
import { getValueOrDefault } from '../../../../../utils/constants';

interface TalkToAgentActionProps {
    actionData: talkToAgentExecutionData,
} 

const TalkToAgentAction: React.FC<TalkToAgentActionProps> = (props) => {
    
    const { actionData } = props;

    const getFullNameOfAgent = () => {
        let agentFullName = "";
        const { agent_first_name } = actionData ?? "";
        const { agent_last_name } = actionData ?? "";

        if(agent_first_name || agent_last_name){
            agentFullName = `${agent_first_name} ${agent_last_name}`;
        } else {
            agentFullName = actionData?.agent_email;
        }
        
        return agentFullName;
    }

    const getConditionText = () => {
        const { condition_group } = actionData;

        let conditionText = null;
        if(condition_group){
            const conditionData = condition_group?.condition_data?.[0]; 

            const variableName = conditionData?.chatbot_custom_variable_name ?? "";
            const operatorName = conditionData?.operator_type_name ?? "";
            const conditionValue = conditionData?.condition_values?.[0]?.condition_value ?? "";

            conditionText = `${variableName} ${operatorName} ${conditionValue}`;
        }

        return getValueOrDefault(conditionText);
    }

    const shouldShowCondition = () => {
        let shouldShowConditionFlag = false;

        if(actionData?.condition_group){
            shouldShowConditionFlag = true;
        }
        return shouldShowConditionFlag;
    }

    return (
        <>
            <Grid container className={`${styles.saveVariableActionMainContainer} ${globalStyles.flexColumn}`} gap={1}>
                <Grid item className={globalStyles.fullwidth}>
                    <Typography className={styles.customAPICallMsgTitle}>
                        Assign Agent
                    </Typography>
                </Grid>
                <Divider />
                <Grid item className={globalStyles.fullwidth}>
                    <Grid container gap={"4px"} flexWrap={"nowrap"} alignItems={"center"}>
                        <Grid item xs={6} className={styles.customAPICallInfoTitle}>
                            Agent  
                        </Grid> 
                        <Grid item xs={5.5}>
                            {getFullNameOfAgent()}
                        </Grid>
                    </Grid>
                </Grid>

                {shouldShowCondition() && 
                    <Grid item className={globalStyles.fullwidth}>
                        <Grid container gap={"4px"} flexWrap={"nowrap"} alignItems={"center"}>
                            <Grid item xs={6} className={styles.customAPICallInfoTitle}>
                                Condition
                            </Grid> 
                            <Grid item xs={5.5}>
                                {getConditionText()}
                            </Grid>
                        </Grid>
                    </Grid>
                }
            </Grid>
        </>
    )
}

export default TalkToAgentAction
